import { createAsyncThunk } from '@reduxjs/toolkit';
import ErrorNotifier, { Severity } from 'app/scripts/services/error-notifier';
import User from 'app/scripts/models/user';
import { fetchLiveBlog } from '../../api';
import { LiveEvent } from '../types';
import { parseLiveEventData } from '../parsers';

interface Payload {
  eventId: string;
}

interface Returned {
  liveEvent: LiveEvent;
  reporters: User[] | any[];
}

export const fetchLiveBlogEvent = createAsyncThunk<Returned, Partial<Payload> | void>(
  'LIVE_BLOG/FETCH_LIVE_BLOG_EVENT',
  async ({ eventId }: Payload) => {
    try {
      const event = await fetchLiveBlog({ eventId });
      const { liveEvent, reporters } = parseLiveEventData(event);

      return { liveEvent, reporters };
    } catch (err) {
      console.error(err);
      ErrorNotifier.notifyError(`Failed to fetch all live blog information list`, {
        level: Severity.Critical
      });
      throw err;
    }
  }
);
